import { all, call, put, takeLatest } from 'redux-saga/effects';
import { ItemShop } from 'actions/actionTypes';
import * as actions from 'actions/itemShop/list';
import { callItemShop } from 'network/apis/itemShop/list';

function* loadItemShopListRequestSaga() {
    try{
        const response = yield call(callItemShop);

        yield put(actions.loadItemShopListSuccess(response.data))
    }
    catch(error){
        yield put(actions.loadItemShopListFailure(error.messgae))
    }
}

export default function* root(){
    yield all([
        takeLatest(ItemShop.LOAD_ITEM_SHOP_LIST_REQUEST, loadItemShopListRequestSaga)
    ]);
}